<div class="max-page-width">

  <div *ngIf="PrivacyPolicyContent != null">
      <div [innerHTML]="PrivacyPolicyContent.contentText | translate"></div>
  </div>

</div>